// extracted by mini-css-extract-plugin
module.exports = {"schoolLogosContainer":"style-module__schoolLogosContainer___WbXMN"};